export class LocationModel {
  constructor(data: any) {
    this.streetNumber = data.streetNumber;
    this.route = data.route;
    this.city = data.city;
    this.county = data.county;
    this.state = data.state;
    this.postalCode = data.postalCode;
  }

  streetNumber: string;
  route: string;
  county: string;
  city: string;
  state: string;
  postalCode: string;

  get valid() {
    let valid: boolean = true;
    Object.getOwnPropertyNames(this)
      .map(key => {
        if (!this[key]) valid = false;
      });
    return valid;
  }

  get fullAddress(): string {
    let address = '';
    if (this.streetNumber) address += this.streetNumber;
    if (address.length) address += ' ';
    if (this.route) address += this.route;
    if (address.length) address += ', ';
    if (this.city) address += this.city;
    if (address.length) address += ', ';
    if (this.state) address += this.state;
    if (this.postalCode) address += ' ' + this.postalCode;
    return address;
  }
}
